module.exports = __webpack_public_path__ + "img/zk-icon-segmentation.d31ca75f.svg";